import { useState, useCallback } from "react";
import { toastService } from "../../../../providers";
import { extractAxiosErrorMessage } from "../../../../services/utils/errorUtils";
import { useUnblockUserPinMutation } from "../../../../hooks/queries/useProfileQueries";

export const useUnblockPinAction = () => {
  const [selectedUser, setSelectedUser] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const { mutate: unblockUserPin, isPending } = useUnblockUserPinMutation();

  const openUnblockModal = useCallback((user) => {
    setSelectedUser(user);
    setModalOpen(true);
  }, []);

  const closeUnblockModal = useCallback(() => {
    setModalOpen(false);
  }, []);

  const handleConfirmUnblock = useCallback(() => {
    if (!selectedUser) return;
    unblockUserPin(selectedUser.id, {
      onSuccess: (data) => {
        toastService.success(data?.remarks || "PIN unblocked successfully!");
        closeUnblockModal();
      },
      onError: (error) => {
        toastService.error(
          extractAxiosErrorMessage(error, "Failed to unblock PIN"),
        );
      },
    });
  }, [selectedUser, unblockUserPin, closeUnblockModal]);

  return {
    selectedUser,
    modalOpen,
    isPending,
    openUnblockModal,
    closeUnblockModal,
    handleConfirmUnblock,
  };
};

export default useUnblockPinAction;
